















































































































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { DatePickerOptionsDate, DatePickerOptionsDateRange, DateSearchTypeList } from '@/utils/componentHelpers';
import { getRedemptionReportModule } from '@/store/modules/moduleReportRedemptions';
import { profileModule } from '@/store/modules/moduleProfile';
import { tablePaginationOptions } from '@/utils/helpers';
import xlsx, { IJsonSheet } from 'json-as-xlsx';
import { Redemption } from '@/api/backplane/BackplaneModels';
import { transformRedemptionsForDisplay, transformRedemptionsForExport } from '@/mappers/RedemptionReportMapper';
import { RedemptionDisplay } from '@/models/RedemptionReportModels';

@Component
export default class WebRedemptionReport extends Vue {
  /* DATA */

  // modules
  private redemptionReportModule = getRedemptionReportModule();

  // dialog appearance
  private dateFromModal = false;
  private dateUntilModal = false;

  // date picker values - OLD todo
  private fromDate = '';
  private untilDate = '';

  // date picker values - NEW todo
  private dateRange = [];
  private datePick = '';
  private dateRangeType = 'dateRange';

  // other
  private search = '';

  private downloadSettings = {
    fileName: `redemptions_report_${this.datePick}`,
    extraLength: 3,
  };

  private isOnlyMine = true;

  public reportHeaders: Array<Record<string, any>> = [
    { text: 'Supplier', align: 'left', sortable: true, value: 'supplier' },
    { text: 'Reseller', align: 'left', sortable: true, value: 'reseller' },
    { text: 'Reference #', align: 'left', sortable: true, value: 'ticket_ref' },
    { text: 'Net Amount', align: 'left', sortable: true, value: 'net_amount' },
    { text: 'Retail Amount', align: 'left', sortable: true, value: 'retail_amount' },
    { text: 'Time Redeemed', align: 'left', sortable: true, value: 'time_redeemed' },
    { text: 'Operator', align: 'left', sortable: true, value: 'operator' },
    { text: 'Travelers', align: 'left', sortable: true, value: 'traveler_count' },
  ];

  private options = DatePickerOptionsDateRange(this.$i18n);

  private optionSingleDay = DatePickerOptionsDate(this.$i18n);

  private dateSearchTypeList = DateSearchTypeList(this.$i18n);

  /* COMPUTED */

  get paginationOptions() {
    return tablePaginationOptions(this.Redemptions);
  }

  private get Redemptions(): Redemption[] {
    return this.redemptionReportModule.Redemptions;
  }

  private get DisplayRedemptions(): RedemptionDisplay[] {
    return transformRedemptionsForDisplay(this.Redemptions);
  }

  private get Loading(): boolean {
    return this.redemptionReportModule.nested.Loading;
  }

  private get UserName(): string {
    if (this.isOnlyMine) {
      if (!profileModule.Profile?.username) {
        // todo alert no profile
      } else {
        return profileModule.Profile?.username;
      }
    }
    return '';
  }

  /* HOOKS */

  async created() {
    this.redemptionReportModule.clearState();
  }

  destroyed() {
    this.redemptionReportModule.clearState();
  }

  /* METHODS */
  download() {
    const data: IJsonSheet[] = [
      {
        sheet: 'Redemptions Report',
        columns: [
          { label: 'Redemption ID', value: 'id' },
          { label: 'Supplier Name', value: 'supplier' },
          { label: 'Reseller Name', value: 'reseller' },
          { label: 'Supplier Ref#', value: 'supplier_ref' },
          { label: 'Reseller Booking Ref#', value: 'reseller_booking_ref' },
          { label: 'Reseller Ref#', value: 'reseller_ref' },
          { label: 'Scanned Ref#', value: 'scanned_ref' },
          { label: 'Operator', value: 'operator' },
          { label: 'Time Redeemed', value: 'time_redeemed' },
          { label: 'Total Net Amount', value: 'net_amount' },
          { label: 'Total Retail Amount', value: 'retail_amount' },
          { label: 'Per Ticket Prices', value: 'per_ticket_amount' },
          { label: 'Traveler Count', value: 'traveler_count' },
          { label: 'Traveler Details', value: 'traveler_details' },
        ],
        content: [{ organization: '' }],
      },
    ];
    data[0].content.push(...transformRedemptionsForExport(this.Redemptions));
    // this.DisplayRedemptions.forEach((redemption) => {
    //   data[0].content.push({
    //     id: redemption.id,
    //     supplierName: redemption.supplierName,
    //     resellerName: redemption.resellerName,
    //     supplierRef: redemption.supplierRef,
    //     resellerRef: redemption.resellerRef,
    //     netAmount: this.formatAmount(redemption.netAmount, redemption.currencyCode),
    //     retailAmount: this.formatAmount(redemption.retailAmount, redemption.currencyCode),
    //     displayTravelers: this.getAgeBandCounts(redemption.travelers),
    //     travelerDetails: this.travelerDetails(redemption.travelers),
    //     displayTicketPrices: this.displayTicketPrices(redemption.prices),
    //   });
    // });
    xlsx(data, this.downloadSettings);
  }

  // event handlers

  private async changeDates(which: string) {
    try {
      this.dateFromModal = false;
      this.dateUntilModal = false;

      const dateRange: {
        fromDate?: moment.Moment | null;
        untilDate?: moment.Moment | null;
      } = {};

      if (which === 'from') {
        dateRange.fromDate = this.fromDate ? moment(this.fromDate) : null;
        this.fromDate = '';
      } else if (which === 'until') {
        dateRange.untilDate = this.untilDate ? moment(this.untilDate) : null;
        this.untilDate = '';
      } else if (which === 'range') {
        if (!this.dateRange) return;

        dateRange.fromDate = this.dateRange[0] ? moment(this.dateRange[0]) : null;
        dateRange.untilDate = this.dateRange[1] ? moment(this.dateRange[1]) : null;
      } else if (which === 'dateSelect') {
        if (this.dateRangeType === 'fromDate') {
          dateRange.fromDate = this.datePick ? moment(this.datePick) : null;
          dateRange.untilDate = null;
        } else if (this.dateRangeType === 'untilDate') {
          dateRange.untilDate = this.datePick ? moment(this.datePick) : null;
          dateRange.fromDate = null;
        }
      }

      await this.redemptionReportModule.changeDates({
        username: this.UserName,
        range: dateRange,
      });
    } catch {
      // todo send alert to backend
    }
  }

  private clearValues() {
    this.dateRange = [];
    this.datePick = '';
  }

  private refresh() {
    this.redemptionReportModule.searchRedemptions({ username: this.UserName }).catch(() => {
      // todo send alert to backend
    });
  }
}
